<template src="./InputCheckboxNormal.html"></template>

<script>
export default {
  name: 'InputCheckboxOne',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    checked: {
      type: Boolean,
      required: false,
      default: () => false
    },
    border: {
      type: Boolean,
      required: false,
      default: () => false
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
    error: {
      type: String,
      required: false,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    justifyContentCenter: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  created() {
    if (this.checked) {
      this.valueInput = true
    }
  },
  data() {
    return {
      valueInput: false,
      distanceWithLabel: '0px',
    }
  },
  watch: {
    checked() {
      this.valueInput = this.checked
    },
    errorText() {
      this.distanceWithLabel = (this.$refs.labelForm?.offsetWidth || 0) + 10 + 'px'
    }
  },
  methods: {
    clickChild() {
      if(!this.disabled) {
        this.valueInput = !this.valueInput
        this.emitChange()
      }
    },
    emitChange() {
      this.$emit('inputValue', this.valueInput)
    }
  }
}
</script>

<style scoped lang="scss">
.input-checkbox {
  label {
    margin-left: 10px;
  }
  input {
    width: 18px;
    height: 18px;
  }
}
</style>
